// extracted by mini-css-extract-plugin
export default {"shirtsWrapper":"shirts_shirtsWrapper__YQOCW","content":"shirts_content__UoC-6","shirtsImage":"shirts_shirtsImage__Q3Qn5"};